import React, {
  FC, useState, useCallback, useEffect,
} from 'react';
import {
  OpenAPI
} from 'simplydo/interfaces';
import RowComponent from 'components/lib/RowComponent';
import api from 'api';
import { Icon } from 'semantic-ui-react';

type PinnedPagesResponse = OpenAPI.GET<'/organisations/pages/pinned'>

type HomePagesProps = {}

const HomePages: FC<HomePagesProps> = () => {
  const [pinnedPages, setPinnedPages] = useState<PinnedPagesResponse['response']['pages']>([]);

  const getPinnedPages = useCallback(() => {
    api.organisations.listPinnedCustomPages(({ pages: newPages }) => {
      setPinnedPages(newPages);
    }, () => {});
  }, []);

  useEffect(() => {
    getPinnedPages();
  }, [getPinnedPages]);

  if (!pinnedPages.length) return null;
  return (
    <RowComponent>
      <RowComponent.Fill>
        <RowComponent.Title>Pages</RowComponent.Title>
      </RowComponent.Fill>
      {pinnedPages.map((page) => (
        <RowComponent.Cell
          key={page._id}
          as='a'
          target='_blank'
          rel='noreferrer'
          href={page.link}
        >
          <Icon name='linkify' size='large' />
          <RowComponent.Title>
            {page.title}
          </RowComponent.Title>
        </RowComponent.Cell>
      ))}
    </RowComponent>
  );
};

export default HomePages;